import { render, staticRenderFns } from "./PaginationInfinite.vue?vue&type=template&id=4f5f128d&scoped=true"
import script from "./PaginationInfinite.vue?vue&type=script&lang=js"
export * from "./PaginationInfinite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f128d",
  null
  
)

export default component.exports